import {
    GET_REPORTS,
    SET_HOLIDAY_REQUEST_STATUS,
    SET_PAGE,
    SET_ROWS_PER_PAGE
} from "./types";
import firebase from "firebase/app";
import moment from "moment";
export const getReports = () => {
    return dispatch => {
        dispatch({ type: GET_REPORTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/reports`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORTS.FAIL });
        }
    };
};
export const setRowsPerPage = (rows = 50) => {
    return dispatch => {
        dispatch({ type: SET_ROWS_PER_PAGE, payload: rows });
    };
};
export const setPage = (page = 1) => {
    return dispatch => {
        dispatch({ type: SET_PAGE, payload: page });
    };
};
export const setHolidayRequestStatus = (
    uid = false,
    status = false,
    timestamp = false,
    reason = ""
) => {
    return async dispatch => {
        dispatch({ type: SET_HOLIDAY_REQUEST_STATUS.REQUEST });
        if (uid && status && timestamp) {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(
                            `/subjects/reports/${uid}/reports/holiday_request/${timestamp}`
                        )
                        .update({
                            manager_approval_date: moment().format(
                                "DD-MM-YYYY HH:mm:ss"
                            ),
                            manager_approval: status,
                            reason
                        })
                        .then(() =>
                            dispatch({
                                type: SET_HOLIDAY_REQUEST_STATUS.SUCCESS
                            })
                        )
                        .catch(() =>
                            dispatch({ type: SET_HOLIDAY_REQUEST_STATUS.FAIL })
                        );
                } else {
                    dispatch({ type: SET_HOLIDAY_REQUEST_STATUS.FAIL });
                }
            });
        } else {
            dispatch({ type: SET_HOLIDAY_REQUEST_STATUS.FAIL });
        }
    };
};
